import styled from 'styled-components';

import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';

export const SelectedFolderDocumentWrapper = styled.div`
  width: 87%;
  margin-left: 0;
`;

export const ClientsWrapper = styled.div`
  width: 20%;
  border-top: 1px solid ${colors.spanishGray};
  border-left: 1px solid ${colors.spanishGray};
  border-bottom: 1px solid ${colors.spanishGray};
`;

export const TreeWrapper = styled.div`
  box-sizing: border-box;
  width: 80%;
  border: 1px solid ${colors.spanishGray};
  padding-top: 3rem;
  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;
    margin-bottom: 21px;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .item-data-container {
    margin-left: -10px;
  }
  .item-tree-container {
    overflow-y: auto;
    height: 680px;
  }
  .action-folder-list {
    display: flex;
    justify-content: end;
    margin-top: 15px;
  }
`;

export const Ul = styled.ul`
  overflow: auto;
  @media ${device.sm} {
    height: 300px;
  }
  @media ${device.md} {
    height: 300px;
  }
  @media ${device.lg} {
    height: 300px;
  }
  @media ${device.xl} {
    height: 720px;
  }
`;

export const ItemDataWrapper = styled.div`
  background-color: ${({ selectedColor }) => selectedColor};
  border: none;
  border-bottom: 1px solid ${colors.lightSilver};
  border-top: 1px solid ${colors.lightSilver};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 18px;
  padding-bottom: 14px;
  padding-left: ${({ level }) => 15 * level + 15}px;
  width: 100%;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
  .info-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    width: 70%;
    .folder-icon {
      height: 25px;
      width: 25px;
      fill: ${colors.black};
    }
    span {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 16px;
    }

    .text-file {
      padding-left: 5px;
    }

    .text-folder {
      margin-top: 5px;
      margin-left: 6px;
    }
  }
  .form-check-input {
    position: initial;
    margin-top: 0;
    margin-left: 0;
  }
  input {
    width: 100%;
    padding: 5px 10px;
    font-size: 12px;
    height: 32px;
    transition: border 0.3s;
    background: transparent;
  }
  .caret {
    fill: ${colors.black};
    height: 18px;
    width: 18px;
  }
`;
